import React from "react";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Student } from "../../../../api";
import { useAuth } from "../../../../hooks";
import "./RecoveryGradeForm.scss";

const studentController = new Student();

export function RecoveryGradeForm(props) {
  const { close, onReload, courseData } = props;
  const { accessToken } = useAuth();

  const formik = useFormik({
    initialValues: initialValues(courseData),
    validationSchema: Yup.object(validationSchema()),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        await studentController.updateRecoveryGrade(
          accessToken,
          courseData.id,
          formValue.recoveryGrade
        );
        onReload();
        close();
      } catch (error) {
        console.error(error);
      }
    },
  });

  return (
    <div className="recovery-grade-form">
      <Form onSubmit={formik.handleSubmit}>
        <div className="course-info">
          <div className="course-info__title">
            <i className="info circle icon" />
            Información del curso
          </div>
          <div className="course-info__item course-info__item--subject">
            <strong>Asignatura:</strong> {courseData.SyllabuSubjectGrade?.subject?.name || "N/A"}
          </div>
          <div className="course-info__item course-info__item--current-grade">
            <strong>Promedio actual:</strong> {courseData.averageGrade}
          </div>
          <div className="course-info__item course-info__item--recovery-grade">
            <strong>Nota de recuperación actual:</strong> {courseData.recoveryGrade || "Sin nota"}
          </div>
        </div>

        <Form.Input
          name="recoveryGrade"
          type="number"
          label="Nota de Recuperación"
          placeholder="Ingrese la nota de recuperación (0-20)"
          onChange={formik.handleChange}
          value={formik.values.recoveryGrade}
          error={formik.errors.recoveryGrade}
          min={0}
          max={20}
          step={1}
        />

        <Form.Button
          type="submit"
          primary
          fluid
          loading={formik.isSubmitting}
        >
          Guardar Nota de Recuperación
        </Form.Button>
      </Form>
    </div>
  );
}

function initialValues(courseData) {
  return {
    recoveryGrade: courseData?.recoveryGrade || "",
  };
}

function validationSchema() {
  return {
    recoveryGrade: Yup.number()
      .required("La nota de recuperación es obligatoria")
      .min(0, "La nota mínima es 0")
      .max(20, "La nota máxima es 20")
      .typeError("Debe ingresar un número válido"),
  };
}
